import { resolverUbicacion } from './useCiudadesTraslado';

// El formulario programa la ida; intercambiar sus puntos no invierte los permisos.
export function motivoIntercambio(values, contexto, departamentos, ciudadesOrigen, ciudadesDestino) {
  if (!contexto) return 'Seleccione una autorización y espere a que se carguen sus ubicaciones permitidas antes de intercambiar.';
  if (!contexto.configurada) return 'Configure las ubicaciones permitidas de la autorización antes de intercambiar.';
  for (const [desde, hacia, ciudades] of [['destino', 'origen', ciudadesDestino], ['origen', 'destino', ciudadesOrigen]]) {
    const lugar = String(values[`${desde}_lugar`] ?? '').trim();
    const departamento = resolverUbicacion(departamentos, values[`${desde}_departamento`]);
    const ciudad = resolverUbicacion(ciudades, values[`${desde}_ciudad`]);
    if (!lugar || ['sin destino', 'pendiente'].includes(lugar.toLowerCase()) || !departamento || !ciudad || Number(ciudad.departamento_id) !== Number(departamento.id)) {
      return 'Complete los lugares, departamentos y ciudades de ambos lados y espere a que carguen antes de intercambiar.';
    }
    const ambito = contexto.ambitos?.[hacia];
    const permitido = ambito?.departamentos?.map(Number).includes(Number(departamento.id)) &&
      (ambito.modo === 'todas' || ambito.ciudades?.map(Number).includes(Number(ciudad.id)));
    if (!permitido) return `No se puede intercambiar: ${ciudad.nombre}, ${departamento.nombre}, no está permitido como ${hacia} en esta autorización.`;
  }
  return '';
}
